import { useEffect, useState } from "react";
import Table from "../../../../../components/common/Table/Table";
import {
  downloadDocument,
  getDocumentsList,
} from "../../../../../store/slices/Citizenship/adminSlice";
import downloadOutline from "/assets/images/downloadOutline.svg";
import { useAppDispatch } from "../../../../../store/hooks";
import { trackButtonClick, trackDocumentUpload } from '../../../../../services/analytics';

// Define TableRow type for document rows
type TableRow = {
  applictnId: string;
  documentName: string;
  documentType: string | JSX.Element;
  contentDescription: string;
  employeeUploadFlag: JSX.Element;
   id: string;
  action: JSX.Element;
};

interface DocumentTabProps {
  applicationData?: {
    empFirstName: string;
    empLastName: string;
    applictnId: string;
    nuid: string;
  };
}

const DocumentTab = ({ applicationData }: DocumentTabProps) => {
  const {
    empFirstName = "",
    empLastName = "",
    applictnId = "",
    nuid = "",
  } = applicationData || {};
  const [documents, setDocuments] = useState<TableRow[]>([]);
  const dispatch = useAppDispatch();
  // Common download button component
  const DownloadButton = ({ onClick }: { onClick?: () => void }) => (
    <button
      className="button -primary -small whitespace-nowrap flex items-center "
      onClick={onClick}
    >
      <img
        src={downloadOutline}
        alt="download icon"
        className="w-6! h-6! flex-shrink-0"
        aria-hidden="true"
      />
      <span>Download</span>
    </button>
  );
  // Document table columns
  const documentColumns = [
    { key: "documentName", label: "Document Name" },
    { key: "documentType", label: "Document Type" },
    {
      key: "contentDescription",
      label: "Document Content Description",
    },
    { key: "employeeUploadFlag", label: "Employee Upload Flag" },
    { key: "action", label: "Action" },
  ];
  const fetchDocuments = async () => {
    try {
      const action = await dispatch<any>(
        getDocumentsList({ applicationId: applictnId, nuid })
      );
      if (getDocumentsList.fulfilled.match(action)) {
        const payload = action.payload;

        if (payload?.items) {
          setDocuments(payload.items);
        } else {
          setDocuments([]);
        }
      } else {
        setDocuments([]);
      }
    } catch (error) {
      console.error("Failed to fetch documents:", error);
      setDocuments([]);
    }
  };
  
  useEffect(() => {
    fetchDocuments();
  }, [applictnId, nuid]);

  const handleDownloadAction = async (
    documentId: string,
    fileName?: string,
  ) => {
    if (!applictnId) {
      console.error("No application id provided.");
      return;
    }
    console.log(`📊 Analytics: Document download - ${fileName || documentId}`);
    trackButtonClick('Download', 'citizenship-document-tab', { documentId, fileName });

    const action = await dispatch<any>(
      downloadDocument({ applicationId: applictnId, documentId ,fileName,nuid})
    );

    if (downloadDocument.fulfilled.match(action)) {
      console.log("Document downloaded successfully.");
      trackDocumentUpload('citizenship', fileName || 'document', true);
    } else {
      console.error("Failed to download document:", action.payload);
      trackDocumentUpload('citizenship', fileName || 'document', false, 'Download failed');
    }
  };

  const rows = documents.map((row) => {
    console.log("Document Content Description:", row.applictnId,row.id);
    return {
      ...row,
      action: (
        <DownloadButton
          onClick={() => handleDownloadAction(row.id, row.documentName)}
        />
      ),
      documentType: (
        <span className="bg-gray-100 border border-[#00000014] rounded px-2! py-1! text-sm font-semibold inline-flex items-center justify-center">
          {row.documentType}
        </span>
      ),
    };
  });

  // Conditionally render the table or a message based on the documents length
  return (
    <div className="margin-top-2u">
      <p className="p3 -book">
        {" "}
        <b>Download Document:</b> Review the list of available documents and
        select the one you need. You can now download <b>one file at a time </b>{" "}
        in its original format.
      </p>
      <p className="p1 -medium ml-5! mt-4!">My documents</p>
      <p className="p3 -book ml-5! mt-2.5!">
        {empFirstName} {empLastName} - Citizenship reimbursement application ID:{" "}
        {applictnId}
      </p>

      <div className="mt-4! ml-5!">
        {documents.length > 0 ? (
          <Table columns={documentColumns} rows={rows} />
        ) : (
          <p className="p3 -book text-center mt-[10px]! text-red-600">
            No documents found for this application.
          </p>
        )}
      </div>
    </div>
  );
};

export default DocumentTab;
